import React from "react";
import { MdCheckCircle } from "@react-icons/all-files/md/MdCheckCircle";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import { useTranslation } from "react-i18next";
import { Dialog, IconButton, Typography, useTheme } from "@mui/material";
import Transition from "@shared/transitionSlideUp";
import { DialogBody } from "./finish.styles";

/**
 * Read-only screen for PENDING_REVIEW / ON_HOLD / PENDING_SAP_CODE (and unknown statuses).
 * Close attempts to exit the WebView, keeping this read-only screen if closing is blocked.
 */
function KycUnderReview() {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleClose = () => {
    try {
      window.close();
    } catch (error) {
      console.error("Unable to close the KYC under-review window:", error);
    }
  };

  return (
    <Dialog
      fullScreen
      open={true}
      TransitionComponent={Transition}
      data-testid="kyc-under-review"
    >
      <IconButton
        aria-label={t("close", { defaultValue: "Close" })}
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: theme.spacing(1),
          right: theme.spacing(1),
          zIndex: 1,
          color: theme.palette.secondary.main,
        }}
      >
        <MdClose size={28} />
      </IconButton>
      <DialogBody
        data-testid="kyc-under-review-content"
        sx={{ top: 0, justifyContent: "center" }}
      >
        <MdCheckCircle size={160} color={theme.palette.primary.main} />
        <Typography color="secondary" variant="h6">
          {t("kyc_under_review_title", { defaultValue: "KYC Under Review" })}
        </Typography>
        <Typography color="secondary">
          {t("kyc_under_review_body", {
            defaultValue:
              "Your KYC documents are under review and cannot be edited at this time.",
          })}
        </Typography>
      </DialogBody>
    </Dialog>
  );
}

export default KycUnderReview;
